export class CompDefinitionTypes {
    public static PERCENT = 'PERCENT';
    public static MANUAL = 'MANUAL';
    public static DEFINED = 'DEFINED';
    public static COMBINED_PRICE = 'COMBINED_PRICE';
}
